import AOS from "aos";

export const aosRefreshEvent = "aos:refresh";

export default () => {
  AOS.init();

  window.addEventListener(aosRefreshEvent, () => {
    AOS.refresh();
  });
};
